import { useApolloClient, useQuery } from '@apollo/client';
import { useTranslation } from '@crehana/i18n';
import { Col, Container, Row } from '@crehana/ui/dist/GridV2';
import Slider from '@crehana/ui/dist/Slider';
import { notEmpty } from '@crehana/utils';
import { useRouter } from 'next/router';

import DownloadableCard from '@/views/B2BLanding/components/DownloadableCard';

import GET_DOWNLOADABLE_RESOURCE_DETAIL from '../../graphql/GetDownloadableResourceDetail.graphql';
import GET_DOWNLOADABLES_RECOMMENDATIONS from '../../graphql/GetDownloadablesRecommendations.graphql';
// biome-ignore lint/style/useImportType: legacy import, will be migrated
import {
  GetDownloadableResourceDetail,
  GetDownloadableResourceDetailVariables,
} from '../../graphql/types/GetDownloadableResourceDetail';
// biome-ignore lint/style/useImportType: legacy import, will be migrated
import {
  GetDownloadablesRecommendations,
  GetDownloadablesRecommendationsVariables,
} from '../../graphql/types/GetDownloadablesRecommendations';

const Recommendations = () => {
  const client = useApolloClient();
  const router = useRouter();
  const { t } = useTranslation();
  const { slug } = router.query as { slug: string };
  const response = client.cache.readQuery<
    GetDownloadableResourceDetail,
    GetDownloadableResourceDetailVariables
  >({
    query: GET_DOWNLOADABLE_RESOURCE_DETAIL,
    variables: {
      slug,
    },
  });

  const { data } = useQuery<
    GetDownloadablesRecommendations,
    GetDownloadablesRecommendationsVariables
  >(GET_DOWNLOADABLES_RECOMMENDATIONS, {
    variables: {
      first: 12,
      tags: response?.resource?.resourceCategory?.slug,
      orderBy: '-publication_date',
    },
  });

  const downloadables =
    data?.resources?.edges.map(el => el?.node).filter(notEmpty) || [];

  if (downloadables.length === 0) {
    return null;
  }

  return (
    <div className="bg-gray-lighter">
      <Container className="py-56">
        <Row>
          <Col className="flex justify-between items-center pb-40">
            <h3 className="font-h3">{t('FORM_RECOMMENDATIONS_TITLE')}</h3>
            <div className="resources" />
          </Col>
        </Row>
        <Row>
          <Col>
            <Slider
              itemsPerPage={{ xs: 1, sm: 3, md: 3, lg: 4 }}
              desktopPaginationSelector=".resources"
              className="py-16"
            >
              {downloadables.map(downloadable => (
                <DownloadableCard
                  key={downloadable.originalId}
                  downloadable={downloadable}
                />
              ))}
            </Slider>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Recommendations;
